// extracted by mini-css-extract-plugin
export var cardSelected = "_fv-2";
export var image = "_fv-1";
export var table = "_fv-0";